/**
 * Determine whether the given string is a locale that makes use of €.
 */
export const isStringEuroCurrencyPreferredApp = (string: string | undefined): boolean =>
    ["en", "fr", "de"].includes(string?.toLowerCase() ?? "")
